// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-field[data-v-79f8591c] {\n  position: relative;\n  color: #d3d3d3;\n}", ""]);
// Exports
module.exports = exports;
